// @flow
import BoostTypes from '../action-types/boost';
import { getSocketIfExist } from '../utils/getSocket';
import { sendAccessBoostWords } from '../utils/ws-v1';

export const addBoostWordsRequest = () => ({
  type: BoostTypes.ADD_BOOST_WORDS_REQUEST,
});

export const addBoostWords = (words: string[], callbacks?: { onSuccess?: Function, onFailure?: Function }) => {
  return async (dispatch: Function, getState: Function) => {
    dispatch(addBoostWordsRequest());

    const ws = getSocketIfExist();
    if (ws) {
      if (callbacks && callbacks.onSuccess) callbacks.onSuccess();
      sendAccessBoostWords(ws, 'add', words.join(','));
    } else {
      if (callbacks && callbacks.onFailure) callbacks.onFailure();
    }
  };
};

export const setAddBoostWordsSuccess = (value: boolean) => ({
  type: BoostTypes.SET_ADD_BOOST_WORDS_SUCCESS,
  payload: value,
});

export const setAddBoostWordsLoading = (value: boolean) => ({
  type: BoostTypes.SET_ADD_BOOST_WORDS_LOADING,
  payload: value,
});

export const deleteBoostWordRequest = () => ({
  type: BoostTypes.DELETE_BOOST_WORD_REQUEST,
});

export const deleteBoostWord = (word: string) => {
  return async (dispatch: Function, getState: Function) => {
    dispatch(deleteBoostWordRequest());

    const ws = getSocketIfExist();
    if (ws) {
      sendAccessBoostWords(ws, 'remove', word);
    }
  };
};

export const setBoostWords = (words: string) => ({
  type: BoostTypes.SET_BOOST_WORDS,
  payload: words,
});
